import { atom } from "jotai";

export const powerUserControlsHelpModalAtom = atom(false);
